import { call, put, takeLatest } from "redux-saga/effects";
import { saveCustomActionApi } from "../../../api/apiLists/workflow";
import { showAlert } from "../../alertSlice";
import {
  saveCustomActionFailure,
  saveCustomActionRequest,
  saveCustomActionStart,
  saveCustomActionSuccess,
  fetchWorkflowCatalogRequest,
  resetWorkflowCatalog
} from "../../slices/workflow";
import { callWorkflowApi, requireWhatsAppModuleAccess } from "./workflowSagaHelper";

function* handleSaveCustomAction(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  try {
    yield put(saveCustomActionStart());

    const req = action.payload || { operation: "SAVE_CUSTOM_ACTION", payload: {} };
    const res = yield callWorkflowApi(saveCustomActionApi, req);

    if (res?.status) {
      yield put(saveCustomActionSuccess(res?.data || null));
      yield put(resetWorkflowCatalog());
      yield put(fetchWorkflowCatalogRequest({
        operation: "GET_CATALOG",
        payload: { catalogType: "all", channel: ["whatsapp"] }
      }));
      yield put(showAlert({
        message: res?.data?.message || "Custom action saved successfully.",
        type: "success"
      }));
      return;
    }

    const errMsg = res?.errMsg || "Failed to save custom action";
    yield put(saveCustomActionFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  } catch (error) {
    const errMsg = error.message || "Failed to save custom action";
    yield put(saveCustomActionFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  }
}

export default function* workflowCustomActionSaga() {
  yield takeLatest(saveCustomActionRequest.type, handleSaveCustomAction);
}
